import * as React from 'react'
import images from '../images'
import DropdownNav from './DropdownNav'
import DropdownAnimation from '../containers/DropdownAnimation'
import AnimationTimer from '../containers/AnimationTimer'
import ViewSwitchButton from '../containers/ViewSwitchButton'
import styled from '../theme/styled'
import KeravaRadarInfo from './KeravaRadarInfo'

const Wrapper = styled.nav`
  position: fixed;
  width: 100%;
  height: ${({ theme }) => `${theme.navbar.height.short}`};
  background: ${({ theme }) => `${theme.color.white}`};
  border-bottom: 1px solid ${({ theme }) => `${theme.color.lightGrey}`};
  z-index: 401;
  box-sizing: content-box;
  top: 0;
  font-family: "Gotham A","Gotham B",Sans-serif; // no Gotham fonts :(

  font-size: medium;
  font-weight: 400;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
    height: ${({ theme }) => `${theme.navbar.height.tall}`}
  }
`
const NormalNavbar = styled.div`
  float: inherit;
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
`

const NavbarLogo = styled.div`
  width: 110px;
  min-width: 110px;
  padding: 18px 18px 18px 18px;
}`

const NavbarMenu = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0;
  padding-left: 0;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
    flex-direction: column;
    align-content: space-around;
  }
`

const NavbarMenuItem = styled.div`
  padding: 0px 20px;
  text-transform: uppercase;
  font-size: medium;
  font-weight: 400;
  color: ${({ theme }) => `${theme.color.textDark}`};
  @media (max-width: ${({ theme }) => `${theme.breakpoint.large}`}) {
    padding: 0px 10px;
  }
`
const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
    justify-content: center;
    padding-top: 20px;
  }
`

const Link = styled.a`
  color: ${({ theme }) => `${theme.color.textDark}`};
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
  color: ${({ theme }) => `${theme.color.textLight}`}
  }
`
const NavBarLinks = styled.div`
display: flex;
min-width: 530px;
@media (max-width: ${({ theme }) => `${theme.breakpoint.large}`}) {
  min-width: 100px;
}
`

const WideBar = styled.div`
  display: flex;
  margin-bottom: 0;
  padding-left: 0;

  @media (max-width: ${({ theme }) => `${theme.breakpoint.large}`}) {
    display: none;
  }
`

const NarrowBar = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => `${theme.breakpoint.large}`}) {
    display: flex;
    margin-bottom: 0;
    padding-left: 0;
  }
`

class NavBar extends React.Component {
  public render() {
    return (
      <Wrapper>
        <NormalNavbar>
          <NavbarMenu>
            <NavbarLogo >
              <Link href="https://www.vaisala.com/en">
                <img src={images.logo} alt="Home" />
              </Link>
            </NavbarLogo>
            <NavBarLinks>
              <WideBar>
                <NavbarMenuItem>
                  <KeravaRadarInfo />
                </NavbarMenuItem>
                <NavbarMenuItem>
                  <Link href="https://www.vaisala.com/en/products/instruments-sensors-and-other-measurement-devices/weather-radar-products/iris-focus">
                    IRIS
                  </Link>
                </NavbarMenuItem>
                <NavbarMenuItem>
                  <Link href="https://www.vaisala.com/en/lp/contact-form">
                    Contact and support
                  </Link>
                </NavbarMenuItem>
              </WideBar>
              <NarrowBar>
                <NavbarMenuItem>
                  <DropdownNav />
                </NavbarMenuItem>
              </NarrowBar>
              <NavbarMenuItem>
                <DropdownAnimation />
              </NavbarMenuItem>
            </NavBarLinks>
            <Buttons>
              <NavbarMenuItem>
                <AnimationTimer />
              </NavbarMenuItem>
              <NavbarMenuItem>
                <ViewSwitchButton />
              </NavbarMenuItem>
            </Buttons>
          </NavbarMenu>
        </NormalNavbar>
      </Wrapper>
    )
  }
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar.tsx